import React from 'react';
import { teacherInfo, teacherStats, benefits } from '../mock';
import { Trophy } from 'lucide-react';

const Teacher = () => {
  return (
    <section id="teacher" className="relative py-28 bg-[#0a0a0a] overflow-hidden">
      {/* subtle grid */}
      <div
        className="absolute inset-0 opacity-[0.04] pointer-events-none"
        style={{
          backgroundImage:
            'linear-gradient(rgba(245,180,68,1) 1px, transparent 1px), linear-gradient(90deg, rgba(245,180,68,1) 1px, transparent 1px)',
          backgroundSize: '60px 60px',
        }}
      />
      <div className="relative max-w-[1400px] mx-auto px-6 lg:px-10">
        <div className="grid lg:grid-cols-12 gap-12 items-center">
          <div className="lg:col-span-5">
            <div className="relative ">
              <div className="absolute -inset-4 bg-amber-400/10 rounded-2xl blur-2xl" />
              <div className="relative rounded-2xl overflow-hidden border border-amber-400/30 max-w-[540px]">
                <img
                  src={require('./images/george.jpg') }
                  alt={teacherInfo.name}
                  className="w-full h-[520px] object-cover grayscale-[20%]"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-[#0a0a0a] via-transparent to-transparent" />
                <div className="absolute bottom-6 left-6 right-6">
                  <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-amber-400/15 border border-amber-400/40 backdrop-blur-sm text-amber-400 text-xs tracking-wider">
                    <Trophy size={13} /> 8 DAN WBADUK
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="lg:col-span-7">
            <p className="text-amber-400 tracking-[0.32em] text-[12px] mb-5 font-medium">YOUR TEACHER</p>
            <h2 className="font-serif text-white text-4xl sm:text-5xl lg:text-[58px] leading-[1.05] tracking-tight">
              {teacherInfo.name},<br />
              <span className="text-amber-400 italic">{teacherInfo.handle}</span>
            </h2>
            <p className="mt-6 text-white/70 text-[16.5px] leading-[1.8] max-w-2xl">
              {teacherInfo.bio}
            </p>

            <div className="mt-10 grid grid-cols-2 sm:grid-cols-4 gap-5">
              {teacherStats.map((s) => (
                <div
                  key={s.label}
                  className="bg-white/[0.03] border border-white/10 hover:border-amber-400/40 transition-colors duration-300 rounded-xl p-5"
                >
                  <div className="text-amber-400 font-serif text-3xl">{s.value}</div>
                  <div className="text-white/55 text-xs mt-1 tracking-wider uppercase">{s.label}</div>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Benefits */}
        <div id="about" className="mt-32 scroll-mt-24">
          <div className="max-w-2xl">
            <p className="text-amber-400 tracking-[0.32em] text-[12px] mb-5 font-medium">WHY GO</p>
            <h2 className="font-serif text-white text-4xl sm:text-5xl lg:text-6xl leading-[1.05] tracking-tight">
              Six reasons to play <span className="text-amber-400 italic">Go</span>
            </h2>
          </div>
          <div className="mt-14 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {benefits.map((b) => (
              <div
                key={b.number}
                className="group relative rounded-2xl border border-white/10 bg-white/[0.02] p-7 hover:border-amber-400/40 hover:bg-white/[0.04] transition-all duration-300"
              >
                <div className="flex items-baseline justify-between mb-4">
                  <h3 className="font-serif text-white text-2xl">{b.title}</h3>
                  <span className="text-amber-400/30 font-serif text-3xl group-hover:text-amber-400/70 transition-colors duration-300">
                    {b.number}
                  </span>
                </div>
                <p className="text-white/60 text-[15px] leading-relaxed">{b.text}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Teacher;
